import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/**
* THIS IS AN AUTO GENERATED FILE, CHANGES WILL NOT APPLY
*/

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 8a2 2 0 11-3.999.001A2 2 0 0116 8M6 10a2 2 0 11-.001-3.999A2 2 0 016 10m9 6.415H5c0-7 10-7 10 0M10 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-18C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0",
  fillRule: "evenodd"
});

var EmojiSadCircle5Icon = function EmojiSadCircle5Icon(_ref) {
  var className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    className: className,
    style: {
      width: size * 10,
      height: size * 10
    },
    fill: "undefined",
    focusable: "false"
  }, rest), _ref2);
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
EmojiSadCircle5Icon.defaultProps = {
  size: 1.5
};
export default EmojiSadCircle5Icon;